import { Actor, Keys, Scene, SpriteSheet, TileMap, Vector } from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";
import { OpenHive } from "../../actors/openHive";
import Bees from "../../actors/bees";
import BoxRepresentation from "../../actors/boxRepresentation";
import Frame from "./frame";
import { goToScene } from "../../main";
import legend from "./../../../res/cellLegend.png";
import {
  addExperience,
  checkFirstInspection,
  checkInspections,
  harvestFrame,
  sendAlert,
  startStingTimer,
} from "../../utils";
import { hiveState, playerState } from "../../state/stateManager";

export default class Inspect extends Scene {
  constructor() {
    super();
    this.player = new Player(90, 60, () => {
      this.setPlayerAnim(false);
    });
    this.holdingFrame = false;
    this.player.scale = new Vector(4, 4);
    this.inspecting = false;
    this.harvestableFrame = null;
    this.selectedFrame = 0;

    this.frameCellSprites = SpriteSheet.fromImageSource({
      image: Resources.FrameCellSprites,
      grid: { rows: 4, columns: 8, spriteHeight: 16, spriteWidth: 16 },
    });
    this.player.z = 3;
    this.player.cutScene = true;
    this.fillOrder = [4, 5, 3, 6, 2, 7, 1, 8, 0, 9];

    this.boxRepresentation = new BoxRepresentation({ x: 20, y: 280 });
    this.bees = new Bees();
    this.boxRepresentation.addChild(this.bees);
    this.activeBoxSprite = "oneOpen";
    this.ui = document.getElementById("inspectUI");
  }
  setPlayerAnim(set) {
    console.log("setting playerAnim: ", set);
    this.playerAnim = set;
  }
  onActivate(data) {
    console.log("data from activation ", data);

    //set hiveStats to state
    this.hiveStats = data.data;
    let hives = hiveState.getHives();
    hives.forEach((hi) => {
      if (hi.birth === data.data.birth) {
        this.hiveStats = hi;
      }
    });
    //get control of ui element for instructions
    this.ui.style.display = "flex";
    this.ui.innerHTML = `<h1>Inspect: ${this.hiveStats.id}</h1>
    <p>Use Up/Down Arrows To Switch Boxes | Enter To Inspect The Box</p>
    <p>Left/Right To Switch Frames | Press S To Use Smoker</p>
    <p id="harvestInfo"></p>
    <div class="legend"><h1>Legend</h1><img src=${legend} /></div>
    
    `;

    //create tilemap for frames
    // this.frameMap = new TileMap({
    //   rows: 13,
    //   columns: 26,
    //   tileWidth: 16,
    //   tileHeight: 16,

    //   //   pos: new Vector(0, 0),
    // });

    //set actors

    this.box = new OpenHive(20, 100, this.hiveStats);

    this.box.scale = new Vector(4, 4);

    // this.add(this.frameMap);
    this.add(this.box);
    this.add(this.player);
    this.add(this.boxRepresentation);
    this.boxRepresentation.graphics.use("open");
    console.log("inspect hiveStats: ", this.hiveStats);

    this.boxes = this.getBroodBoxes(this.hiveStats);

    this.activeBox = this.hiveStats.overallFrames.boxes - 1;
    this.harvestInfo = document.getElementById("harvestInfo");
    console.log("inspect: broodBoxes return: ", this.boxes);

    this.honeyBoxes = this.getHoneyBoxes(this.hiveStats);
    console.log("inspect: honeyBoxes return: ", this.honeyBoxes);
    this.beeBoxes = this.getBees(this.hiveStats);
    console.log("inspect: beeBoxes return: ", this.beeBoxes);

    console.log("inspect: activeBox is : ", this.activeBox);

    const broodAmount = this.hiveStats.overallFrames.queenAccess / 10;
    const honeyAmount =
      (this.hiveStats.overallFrames.count -
        this.hiveStats.overallFrames.queenAccess) /
      10;

    if (honeyAmount > 0) {
      this.allBoxes = this.boxes.concat(this.honeyBoxes);
    } else {
      this.allBoxes = this.boxes;
    }
    //iterate playerState inspections by 1
    let content = playerState.getContent();
    content.inspections++;
    playerState.setContent(content);
    checkInspections(content.inspections);
    addExperience(1);
    if (!this.hiveStats.alive) {
      Resources.BeeSounds.stop();
    } else {
      this.stingTimer = startStingTimer(
        this.hiveStats,
        "inspect",
        this.camera,
        () => {
          //check for stingTolerance, if over, kick back to proper scene
          let content = playerState.getContent();
          if (content.stings.count >= content.stingTolerance) {
            sendAlert("Over Sting Tolerance. Not Enough Zeal.");
            this.ui.style.display = "none";
            if (this.hiveStats.position.yard == "home") {
              goToScene("home");
            } else {
              goToScene("back40", {
                x: this.hiveStats.position.x,
                y: this.hiveStats.position.y,
              });
            }
          }
        }
      );
      this.stingTimer.start();
    }
  }
  onPostUpdate() {
    if (!this.playerAnim && !this.holdingFrame) {
      this.player.graphics.use("leftIdleBobble");
    } else if (!this.playerAnim && this.holdingFrame) {
      this.player.graphics.use("holdingFrame");
    }

    let activeSprite = this.getBoxSprite();

    this.box.graphics.use(activeSprite);
    if (this.hiveStats.alive) {
      let beeAnimation = this.getBeesSprite(this.beeBoxes[this.activeBox]);
      if (
        beeAnimation !== null &&
        beeAnimation !== undefined &&
        this.beeBoxes[this.activeBox] !== 0
      ) {
        this.bees.graphics.use(beeAnimation);
      } else {
        this.box.flyingActor.graphics.hide();
        this.bees.graphics.hide();
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Down)) {
      //change activeBox
      if (this.activeBox === 0) {
        this.activeBox = this.allBoxes.length - 1;
        Resources.PullFrame.play();
      } else {
        Resources.PullFrame.play();
        this.activeBox = this.activeBox - 1;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Up)) {
      //change activeBox
      if (this.activeBox === this.allBoxes.length - 1) {
        Resources.PullFrame.play();
        this.activeBox = 0;
      } else {
        Resources.PullFrame.play();
        this.activeBox++;
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.S)) {
      console.log("setting lastSmoked");
      let hives = hiveState.getHives();
      hives.forEach((hi, i) => {
        if (hi.birth === this.hiveStats.birth) {
          hi.lastSmoked = new Date().getTime();
        }
      });
      hiveState.setHives(hives);
      if (!this.playerAnim) {
        console.log("setting leftSmoke playerAnim");
        this.setPlayerAnim(true);
        this.holdingFrame = false;
        this.player.doAnim("left-smoke");
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      if (!this.inspecting) {
        this.inspecting = true;
        this.boxRepresentation.graphics.use("openOne");
        this.openFrameInspection(this.allBoxes[this.activeBox], 0);
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.H)) {
      if (
        this.harvestableFrame !== null &&
        this.harvestableFrame !== undefined
      ) {
        console.log("harvestable: ", this.harvestableFrame);
        let hares = harvestFrame(this.hiveStats, this.harvestableFrame);
        if (hares) {
          this.inspecting = false;
          this.ui.style.display = "none";
          this.frameObject.removeAllChildren();
          this.frameObject.kill();
          this.inspecting = false;
          this.playerAnim = false;
          this.holdingFrame = false;
          if (this.hiveStats.position.yard == "home") {
            goToScene("home");
          } else {
            goToScene("back40", {
              x: this.hiveStats.position.x,
              y: this.hiveStats.position.y,
            });
          }
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Left)) {
      if (this.inspecting) {
        if (this.selectedFrame == 0) {
          this.selectedFrame = 9;
        } else {
          this.selectedFrame = this.selectedFrame - 1;
        }
        console.log(
          "getBoxRepresentationSprite: ",
          this.getBoxRepresentationSprite(this.selectedFrame)
        );
        this.boxRepresentation.graphics.use(
          this.getBoxRepresentationSprite(this.selectedFrame)
        );
        this.openFrameInspection(
          this.allBoxes[this.activeBox],
          this.selectedFrame
        );
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Right)) {
      console.log("pressed right, : ", this.allBoxes[this.activeBox]);
      if (this.inspecting) {
        if (this.selectedFrame == 9) {
          this.selectedFrame = 0;
        } else {
          this.selectedFrame++;
        }
        console.log(
          "getBoxRepresentationSprite: ",
          this.getBoxRepresentationSprite(this.selectedFrame)
        );
        this.boxRepresentation.graphics.use(
          this.getBoxRepresentationSprite(this.selectedFrame)
        );
        this.openFrameInspection(
          this.allBoxes[this.activeBox],
          this.selectedFrame
        );
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.inspecting) {
        //cancel box inspection
        this.inspecting = false;

        // for (let i = 0; i < this.frameObject.tiles.length; i++) {
        //   this.frameObject.tiles[i].kill();
        // }
        this.frameObject.removeAllChildren();
        this.frameObject.kill();
        this.boxRepresentation.graphics.use("open");
        this.holdingFrame = false;
        this.selectedFrame = 0;
        this.harvestInfo.innerHTML = ``;
      } else {
        this.ui.style.display = "none";
        if (this.hiveStats.position.yard == "home") {
          goToScene("home");
        } else {
          goToScene("back40", {
            x: this.hiveStats.position.x,
            y: this.hiveStats.position.y,
          });
        }
      }
    }
  }
  onDeactivate() {
    this.box.kill();
    this.boxRepresentation.kill();
    this.player.kill();
    this.stingTimer && this.stingTimer.stop();
  }
  openFrameInspection(boxObject, frameIndex) {
    if (this.frameObject) {
      this.frameObject.kill();
    }
    Resources.PullFrame.play();
    checkFirstInspection();

    console.log("inside openFrameInspection: ", boxObject, frameIndex);
    this.setPlayerAnim(true);
    this.holdingFrame = true;
    this.player.doAnim("pickupFrame");
    if (
      boxObject.frames[frameIndex].type == "honey" ||
      boxObject.frames[frameIndex].type == "food"
    ) {
      console.log("have harvestable");
      this.harvestInfo.innerHTML = `H> Harvest Frame`;
      this.harvestableFrame = boxObject.frames[frameIndex];
    } else {
      console.log("inspect: not harvestable");
      this.harvestInfo.innerHTML = ``;
      this.harvestableFrame = null;
    }
    this.frameObject = new Frame(boxObject.frames[frameIndex], this);
    this.add(this.frameObject);
  }
  getBoxSprite() {
    if (this.hiveStats.overallFrames.queenAccess == 10) {
      //one brood box
      switch (this.activeBox) {
        case 0:
          return "oneOpen";
          break;
        case 1:
          return "oneOneOpen";
          break;
        case 2:
          return "oneTwoOpen";
          break;
        case 3:
          return "oneThreeOpen";
          break;
        case 4:
          return "oneFourOpen";
          break;
        case 5:
          return "oneFiveOpen";
          break;
        default:
          return "oneOpen";
          break;
      }
    } else if (this.hiveStats.overallFrames.queenAccess == 20) {
      //two brood boxes
      switch (this.activeBox) {
        case 0:
          return "oneOpen";
          break;
        case 1:
          return "twoOpen";
          break;
        case 2:
          return "twoOneOpen";
          break;
        case 3:
          return "twoTwoOpen";
          break;
        case 4:
          return "twoThreeOpen";
          break;
        case 5:
          return "twoFourOpen";
          break;
        default:
          return "oneOpen";
      }
    }
  }
  getBoxRepresentationSprite(frame) {
    switch (frame) {
      case 0:
        return "openOne";
        break;
      case 1:
        return "openTwo";
        break;
      case 2:
        return "openThree";
        break;
      case 3:
        return "openFour";
        break;
      case 4:
        return "openFive";
        break;
      case 5:
        return "openSix";
        break;
      case 6:
        return "openSeven";
        break;
      case 7:
        return "openEight";
        break;
      case 8:
        return "openNine";
        break;
      case 9:
        return "openTen";
        break;
      default:
        break;
    }
  }
  getBeesSprite(bees) {
    if (bees <= 2 && bees > 0) {
      return "oneChurn";
    } else if (bees > 1 && bees <= 2) {
      return "twoChurn";
    } else if (bees > 2 && bees <= 3) {
      return "threeChurn";
    } else if (bees > 3 && bees <= 4) {
      return "fourChurn";
    } else if (bees > 4 && bees <= 5) {
      return "fiveChurn";
    } else if (bees > 5 && bees <= 6) {
      return "sixChurn";
    } else if (bees > 6 && bees <= 7) {
      return "sevenChurn";
    } else if (bees > 7 && bees <= 8) {
      return "eightChurn";
    } else if (bees > 8 && bees <= 9) {
      return "nineChurn";
    } else if (bees > 9 && bees <= 10) {
      return "tenChurn";
    } else if (bees > 10 && bees <= 13) {
      return "hundredFifty";
    } else if (bees > 13) {
      return "twoHundred";
    }
  }
  getHoneyBoxes(hive) {
    let honeyBoxes = [];
    if (hive.overallFrames.count - hive.overallFrames.queenAccess > 1) {
      //have honey frames
      let availableHoneyFrames =
        hive.overallFrames.count - hive.overallFrames.queenAccess;
      let boxCount = availableHoneyFrames / 10;
      for (let i = 0; i < boxCount; i++) {
        honeyBoxes.push({
          type: "honey",
          frames: [
            { index: 0, type: "empty" },
            { index: 1, type: "empty" },
            { index: 2, type: "empty" },
            { index: 3, type: "empty" },
            { index: 4, type: "empty" },
            { index: 5, type: "empty" },
            { index: 6, type: "empty" },
            { index: 7, type: "empty" },
            { index: 8, type: "empty" },
            { index: 9, type: "empty" },
          ],
        });
      }
      //add honey frames
      let honeyFramesToAdd = hive.honeyFrames.count;
      for (let i = 0; i < hive.honeyFrames.count; i++) {
        console.log(
          "inspect: adding ",
          hive.honeyFrames.count - i,
          " food frames, framesToAdd: ",
          honeyFramesToAdd
        );

        honeyBoxes.forEach((box, g) => {
          for (let a = 0; a < this.fillOrder.length; a++) {
            if (honeyFramesToAdd > 0) {
              let completion = 100;
              if (honeyFramesToAdd < 1) {
                console.log("inspect:frame should be partial");
                completion = honeyFramesToAdd;
              }
              if (box.frames[this.fillOrder[a]].type == "empty") {
                console.log();
                honeyBoxes[g].frames[this.fillOrder[a]] = {
                  index: this.fillOrder[a],
                  type: "honey",
                  fillCompletion: completion,
                };
                honeyFramesToAdd = honeyFramesToAdd - 1;
                console.log("inspect: honeyFramesToAdd: ", honeyFramesToAdd);
                continue;
              }
            }
          }
        });
      }
    }
    return honeyBoxes;
  }
  getBees(hive) {
    let beeFramesToAdd = hive.beeFrames.count;
    let boxes = hive.overallFrames.boxes;
    let beeBoxes = [];
    for (let i = 0; i < hive.overallFrames.boxes; i++) {
      console.log("inspect: adding beeBox");
      if (i == boxes - 1) {
        //last box
        console.log("inspect: last beeBox");
        beeBoxes.push(beeFramesToAdd);
        beeFramesToAdd = 0;
      } else {
        if (beeFramesToAdd > 10) {
          beeBoxes.push(10);
          beeFramesToAdd = beeFramesToAdd - 10;
        } else if (beeFramesToAdd > 0) {
          beeBoxes.push(beeFramesToAdd);
          beeFramesToAdd = 0;
        } else {
          beeBoxes.push(0);
        }
      }
    }
    console.log("inspect: beeBoxes: ", beeBoxes);
    return beeBoxes;
  }
  getBroodBoxes(hive) {
    let broodBoxes = [];
    let honeyBoxes = [];
    const boxCount = hive.overallFrames.boxes;
    const broodAmount = hive.overallFrames.queenAccess / 10;
    const honeyAmount =
      (hive.overallFrames.count - hive.overallFrames.queenAccess) / 10;
    for (let i = 0; i < broodAmount; i++) {
      broodBoxes.push({
        type: "brood",
        frames: [
          { index: 0, type: "empty" },
          { index: 1, type: "empty" },
          { index: 2, type: "empty" },
          { index: 3, type: "empty" },
          { index: 4, type: "empty" },
          { index: 5, type: "empty" },
          { index: 6, type: "empty" },
          { index: 7, type: "empty" },
          { index: 8, type: "empty" },
          { index: 9, type: "empty" },
        ],
      });
    }
    for (let i = 0; i < honeyAmount; i++) {
      honeyBoxes.push({
        type: "honey",
        frames: [
          { index: 0, type: "empty" },
          { index: 1, type: "empty" },
          { index: 2, type: "empty" },
          { index: 3, type: "empty" },
          { index: 4, type: "empty" },
          { index: 5, type: "empty" },
          { index: 6, type: "empty" },
          { index: 7, type: "empty" },
          { index: 8, type: "empty" },
          { index: 9, type: "empty" },
        ],
      });
    }

    let foodFramesToAdd = hive.foodFrames.count;

    //add brood frames
    let unfinishedBroodFrame =
      hive.broodFrames.count - Math.floor(hive.broodFrames.count);
    let queenCellsToAdd = [];
    if (hive.queenCells.cells.length > 0) {
      queenCellsToAdd = [...hive.queenCells.cells];
      console.log("inspect: have queen cells: ", hive.queenCells.cells);
    }
    hive.broodFrames.frames.forEach((frame, i) => {
      console.log("inspect: adding frame: ", frame);
      console.log("inspect: queenCellsToAdd: ", queenCellsToAdd);
      if (hive.broodFrames.count > 10) {
        //more than one box of brood
        let boxIndex = Math.floor(i / 10);
        console.log("inspect: brood: boxIndex: ", boxIndex);
        let fillOrderIndex = i;
        if (i > 9) {
          fillOrderIndex = i - 10;
        }
        if (queenCellsToAdd.length > 0) {
          broodBoxes[boxIndex].frames[this.fillOrder[fillOrderIndex]] = {
            index: this.fillOrder[fillOrderIndex],
            age: frame.index,
            spotty: frame.spotty,
            type: "brood",
            fillCompletion: 100,
            queenCell: queenCellsToAdd[0],
          };
          queenCellsToAdd.splice(0, 1);
        } else {
          broodBoxes[boxIndex].frames[this.fillOrder[fillOrderIndex]] = {
            index: this.fillOrder[fillOrderIndex],
            age: frame.index,
            spotty: frame.spotty,
            type: "brood",
            fillCompletion: 100,
            queenCell: null,
          };
        }
      } else {
        if (queenCellsToAdd.length > 0) {
          console.log("inspect, should fill the ", this.fillOrder[i], " frame");
          broodBoxes[0].frames[this.fillOrder[i]] = {
            index: this.fillOrder[i],
            age: frame.index,
            spotty: frame.spotty,
            type: "brood",
            fillCompletion: 100,
            queenCell: queenCellsToAdd[0],
          };
          queenCellsToAdd.splice(0, 1);
        } else {
          console.log("inspect, should fill the ", this.fillOrder[i], " frame");
          broodBoxes[0].frames[this.fillOrder[i]] = {
            index: this.fillOrder[i],
            age: frame.index,
            spotty: frame.spotty,
            type: "brood",
            fillCompletion: 100,
            queenCell: null,
          };
        }
      }
    });
    //should figure out next available brood frame and add partial
    let addedPartial = false;
    broodBoxes.forEach((box, i) => {
      for (let a = 0; a < this.fillOrder.length; a++) {
        if (box.frames[this.fillOrder[a]].type == "empty") {
          console.log(
            "inspect,found empty frame for partialFrame, box: ",
            i,
            " frame: ",
            box.frames[this.fillOrder[a]]
          );
          if (!addedPartial && unfinishedBroodFrame > 0) {
            broodBoxes[i].frames[this.fillOrder[a]] = {
              index: this.fillOrder[a],
              type: "brood",
              age: 0,
              fillCompletion: unfinishedBroodFrame,
            };
            addedPartial = true;
          }
          return;
        }
      }
    });

    //add food frames
    for (let i = 0; i < hive.foodFrames.count; i++) {
      console.log(
        "inspect: adding ",
        hive.foodFrames.count - i,
        " food frames, framesToAdd: ",
        foodFramesToAdd
      );

      broodBoxes.forEach((box, g) => {
        for (let a = 0; a < this.fillOrder.length; a++) {
          if (foodFramesToAdd > 0) {
            let completion = 100;
            if (foodFramesToAdd < 1) {
              console.log("inspect:frame should be partial");
              completion = foodFramesToAdd;
            }
            if (box.frames[this.fillOrder[a]].type == "empty") {
              console.log();
              broodBoxes[g].frames[this.fillOrder[a]] = {
                index: this.fillOrder[a],
                type: "food",
                fillCompletion: completion,
              };
              foodFramesToAdd = foodFramesToAdd - 1;
              console.log("inspect: foodFramesToAdd: ", foodFramesToAdd);
              continue;
            }
          }
        }
      });
    }
    console.log("inspect: broodBoxes: ", broodBoxes);
    return broodBoxes;

    // boxes.forEach((box, i) => {
    //   letAddedFrames = 0;
    //   if (box.type == 'brood'){
    //     for (i = 0,i < fillOrder.length;i++){
    //       box.frames[fillOrder[i]] =
    //     }
    //   }else if (box.type == 'honey'){

    //   }
    // });
  }
}
